import { useQuery } from "@tanstack/react-query";
import { adminApi } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function ErrorsPage(): import("react").ReactElement {
  const errors = useQuery({ queryKey: ["errors"], queryFn: adminApi.errors });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Error Logs</h1>
        <p className="text-sm text-muted-foreground">Recent structured errors mirrored to KV by the Worker logger.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Recent Errors</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {errors.data?.errors.map((error, index) => (
              <pre key={index} className="overflow-x-auto rounded-md border bg-muted p-3 text-xs">
                {JSON.stringify(error, null, 2)}
              </pre>
            ))}
            {errors.data?.errors.length === 0 && <p className="text-sm text-muted-foreground">No errors recorded.</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
